import React from "react"

import { Typography } from "@mui/material"

import { useTranslations } from "@cirrus/core/i18n"
import { DeliveryDialog, DeliveryDialogProps } from "@cirrus-delivery/v2/features/Dialog/shared/DeliveryDialog"

export interface EssayWordCountDialogProps extends DeliveryDialogProps {
  wordCount: number
  minWordCount: number
  onConfirm?: () => void
  onClose?: () => void
}

/**
 * Essay Word Count Warning Dialog
 *
 * Shown when user tries to navigate away from an essay question
 * that doesn't meet the minimum word count requirement.
 *
 * Shared component used by both v1 and v2 delivery apps.
 */
export const EssayWordCountDialog = (props: EssayWordCountDialogProps) => {
  const { wordCount, minWordCount, onConfirm, onClose, ...restDialogProps } = props

  const { i18n } = useTranslations()

  function handleContinue() {
    onConfirm?.()
    onClose?.()
  }

  function handleStay() {
    onClose?.()
  }

  return (
    <DeliveryDialog {...restDialogProps} onClose={handleStay}>
      <DeliveryDialog.WarningIcon />

      <DeliveryDialog.Title>{i18n("General:Notification")}</DeliveryDialog.Title>

      <DeliveryDialog.Content>
        <Typography lineHeight="2rem">
          {i18n("Delivery:EssayMinWordCountWarning")
            .replace("{0}", wordCount.toString())
            .replace("{1}", minWordCount.toString())}
        </Typography>
      </DeliveryDialog.Content>

      <DeliveryDialog.Actions>
        <DeliveryDialog.ActionButton variant="outlined" onClick={handleStay} autoFocus>
          {i18n("General:Stay")}
        </DeliveryDialog.ActionButton>

        <DeliveryDialog.ActionButton variant="contained" color="success" onClick={handleContinue}>
          {i18n("General:Continue")}
        </DeliveryDialog.ActionButton>
      </DeliveryDialog.Actions>
    </DeliveryDialog>
  )
}
